export default "__VITE_ASSET__BF42TyWz__"